import { Routes } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';
import { LocationGuard } from '@next/core-lib/relationships';

import { MeasurementsComponent } from './height-measurement/components/measurements/measurements.component';
import { MeasurementsGraphComponent } from './height-measurement/components/measurements-graph/measurements-graph.component';
import { MeasurementsOverviewComponent } from './height-measurement/components/measurements-overview/measurements-overview.component';
import { HeightMeasurementComponent } from './height-measurement/height-measurement.component';
import { AlvaTabComponent } from './insemination-advice/components/alva-tab/alva-tab.component';
import { InseminationOverviewComponent } from './insemination-advice/components/insemination-overview/insemination-overview.component';
import { InseminationAdviceComponent } from './insemination-advice/insemination-advice.component';

export const appRoutes: Routes = [
  {
    path: 'height-measurements',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    component: HeightMeasurementComponent,
    canActivate: [LocationGuard],
    children: [
      {
        path: 'measurements',
        component: MeasurementsComponent,
      },
      {
        path: 'overview',
        component: MeasurementsOverviewComponent,
      },
      {
        path: '',
        redirectTo: 'measurements',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'monitoring',
    canActivate: [LocationGuard],
    component: MeasurementsGraphComponent,
  },
  {
    path: 'monitoring/cow/:cowId',
    canActivate: [LocationGuard],
    component: MeasurementsGraphComponent,
  },
  {
    path: 'insemination-advice',
    component: InseminationAdviceComponent,
    canActivate: [LocationGuard],
    children: [
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full',
      },
      {
        path: 'overview',
        component: InseminationOverviewComponent,
      },
      {
        path: 'alva',
        component: AlvaTabComponent,
      },
    ],
  },
  ...coreRoutes,
];
